// VideoBackground.js
import React from 'react';
import '../style/WhoWeAre.scss';
import { FaBriefcase, FaUsers, FaProjectDiagram } from "react-icons/fa";

const WhoWeAre = () => {
  return (
    <div className="container-WhoWeAre">
    
    <h2 className="title">Who Are We ?</h2>
    <p className="description">
    We are a creative team of digital experts passionate about building websites, designing brands, and bringing ideas to life. From web design to SEO, social media, and content creation — we help your business grow with style and purpose.
    </p>
    
    <div className="cards">
      <div className="card card-1" id='card-1'>
        <div className="icon"/>
        <h3></h3><br/><br/><br/>
        
      </div>
      <div className="card card-2"  id='card-2'>
        <div className="icon"/><br/><br/><br/>
        <h3></h3><br/><br/><br/>
        
      </div>
      <div className="card card-3" id='card-3'>
        <div className="icon"/>
        <h3></h3><br/><br/><br/>
        
      </div>
    </div>
  </div>
  
  );
};

export default WhoWeAre;
